import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	footermenu: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(4),
		[theme.breakpoints.up("md")]: {
			gridColumn: "1 / 2",
			gridRow: 2
		},
		[theme.breakpoints.up("lg")]: {
			gridColumn: "3 / 4",
			gridRow: 1,
			justifyContent: "space-between"
		},
		"& > div div:last-child a": {
			marginBottom: 0
		}
	},
	mainLink: {
		color: theme.palette.text.primary,
		display: "inline-block",
		marginBottom: theme.spacing(2),
		transition: "color 250ms ease",
		"&:hover": {
			color: theme.palette.text.secondary
		}
	},
	mainLinkSelected: {
		textDecoration: "underline",
		textUnderlineOffset: 4
	},
	subLink: {
		color: theme.palette.text.primary,
		display: "inline-block",
		marginBottom: 8,
		transition: "color 250ms ease",
		"&:hover": {
			color: theme.palette.text.secondary
		}
	},
	subLinkSelected: {
		textDecoration: "underline",
		textUnderlineOffset: 4
	}
}));

export default styles;
